// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"de023ec6","outerContainer":"a6dff90c","secondaryToolbar":"de4ae97d","doorHangerRight":"_0e4b33a3","toolbarContainer":"_2084e73f","toolbarViewerMiddle":"_1a2b4263","progressBar":"eb6b60d0","back-to-application":"a6d66b61","card":"_0a5db05f","wrapper":"_10c2e35c","content":"e3b2086b","avatar":"_460fee5e","title":"_78e8565e","subtitle":"e64c04ca","badge":"f522c49d","badge-text":"_038fd6e3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Communities/Components/HorizontalCard/index.styl
// module id = 4931
// module chunks = 39